import styled from 'styled-components';
import { metrics, colors as customColors } from '../../../theme/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, Button as ButtonMUI } from '@mui/material';

export const Icon = styled(AccountCircleIcon)`
  height: ${metrics.sizeIconCredential};
  width: ${metrics.sizeIconCredential};
`;

export const Content = styled(Box)`
  text-align: center;
  width: 80%;
  margin-top: 1rem;
`;

export const Title = styled.h1`
  font-size: ${metrics.titleCredential};
  margin: 0;
`;

export const Subtitle = styled.h5`
  margin: 0;
  font-weight: ${metrics.weight.regular};
  color: ${customColors.black};
  font-size: ${metrics.size.small};
  text-align: initial;
`;

export const ButtonGroup = styled.div`
  margin: 1.2rem 0;
`;

export const Button = styled(ButtonMUI)`
  && {
    width: 100%;
    margin-bottom: 0.8rem;
  }
`;

export const Links = styled.div`
  width: 100%;
  text-align: right;
  margin: 0.8rem 0 0.8rem 0;

  p {
    margin: 0;
    margin-top: 0.5rem;
  }
`;
